import { SVGProps } from "react";
const Preference = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      d="M9.6013 13.8337H6.4013C3.47464 13.8337 2.16797 12.527 2.16797 9.60033V6.40033C2.16797 3.47366 3.47464 2.16699 6.4013 2.16699H9.6013C12.528 2.16699 13.8346 3.47366 13.8346 6.40033V9.60033C13.8346 12.527 12.528 13.8337 9.6013 13.8337ZM6.4013 3.16699C4.01464 3.16699 3.16797 4.01366 3.16797 6.40033V9.60033C3.16797 11.987 4.01464 12.8337 6.4013 12.8337H9.6013C11.988 12.8337 12.8346 11.987 12.8346 9.60033V6.40033C12.8346 4.01366 11.988 3.16699 9.6013 3.16699H6.4013Z"
      fill="black"
    />
    <path
      d="M9.0013 11.8337H7.0013C5.06797 11.8337 4.16797 10.9337 4.16797 9.00033V7.00033C4.16797 5.06699 5.06797 4.16699 7.0013 4.16699H9.0013C10.9346 4.16699 11.8346 5.06699 11.8346 7.00033V9.00033C11.8346 10.9337 10.9346 11.8337 9.0013 11.8337ZM7.0013 5.16699C5.61464 5.16699 5.16797 5.61366 5.16797 7.00033V9.00033C5.16797 10.387 5.61464 10.8337 7.0013 10.8337H9.0013C10.388 10.8337 10.8346 10.387 10.8346 9.00033V7.00033C10.8346 5.61366 10.388 5.16699 9.0013 5.16699H7.0013Z"
      fill="black"
    />
    <path
      d="M5.33984 3.16634C5.05984 3.16634 4.83984 2.93967 4.83984 2.66634V1.33301C4.83984 1.05967 5.06651 0.833008 5.33984 0.833008C5.61318 0.833008 5.83984 1.05967 5.83984 1.33301V2.66634C5.83984 2.93967 5.61318 3.16634 5.33984 3.16634Z"
      fill="black"
    />
    <path
      d="M8 3.16634C7.72667 3.16634 7.5 2.93967 7.5 2.66634V1.33301C7.5 1.05967 7.72667 0.833008 8 0.833008C8.27333 0.833008 8.5 1.05967 8.5 1.33301V2.66634C8.5 2.93967 8.27333 3.16634 8 3.16634Z"
      fill="black"
    />
    <path
      d="M10.668 3.16634C10.3946 3.16634 10.168 2.93967 10.168 2.66634V1.33301C10.168 1.05967 10.3946 0.833008 10.668 0.833008C10.9413 0.833008 11.168 1.05967 11.168 1.33301V2.66634C11.168 2.93967 10.9413 3.16634 10.668 3.16634Z"
      fill="black"
    />
    <path
      d="M14.6654 5.83301H13.332C13.0587 5.83301 12.832 5.60634 12.832 5.33301C12.832 5.05967 13.0587 4.83301 13.332 4.83301H14.6654C14.9387 4.83301 15.1654 5.05967 15.1654 5.33301C15.1654 5.60634 14.9454 5.83301 14.6654 5.83301Z"
      fill="black"
    />
    <path
      d="M14.6654 8.5H13.332C13.0587 8.5 12.832 8.27333 12.832 8C12.832 7.72667 13.0587 7.5 13.332 7.5H14.6654C14.9387 7.5 15.1654 7.72667 15.1654 8C15.1654 8.27333 14.9454 8.5 14.6654 8.5Z"
      fill="black"
    />
    <path
      d="M14.6654 11.167H13.332C13.0587 11.167 12.832 10.9403 12.832 10.667C12.832 10.3937 13.0587 10.167 13.332 10.167H14.6654C14.9387 10.167 15.1654 10.3937 15.1654 10.667C15.1654 10.9403 14.9454 11.167 14.6654 11.167Z"
      fill="black"
    />
    <path
      d="M10.668 15.1663C10.3946 15.1663 10.168 14.9397 10.168 14.6663V13.333C10.168 13.0597 10.3946 12.833 10.668 12.833C10.9413 12.833 11.168 13.0597 11.168 13.333V14.6663C11.168 14.9397 10.9413 15.1663 10.668 15.1663Z"
      fill="black"
    />
    <path
      d="M8.00781 15.1663C7.73448 15.1663 7.50781 14.9397 7.50781 14.6663V13.333C7.50781 13.0597 7.73448 12.833 8.00781 12.833C8.28115 12.833 8.50781 13.0597 8.50781 13.333V14.6663C8.50781 14.9397 8.28115 15.1663 8.00781 15.1663Z"
      fill="black"
    />
    <path
      d="M5.33984 15.1663C5.06651 15.1663 4.83984 14.9397 4.83984 14.6663V13.333C4.83984 13.0597 5.06651 12.833 5.33984 12.833C5.61318 12.833 5.83984 13.0597 5.83984 13.333V14.6663C5.83984 14.9397 5.61318 15.1663 5.33984 15.1663Z"
      fill="black"
    />
    <path
      d="M2.66536 5.83301H1.33203C1.0587 5.83301 0.832031 5.61301 0.832031 5.33301C0.832031 5.05301 1.0587 4.83301 1.33203 4.83301H2.66536C2.9387 4.83301 3.16536 5.05967 3.16536 5.33301C3.16536 5.60634 2.94536 5.83301 2.66536 5.83301Z"
      fill="black"
    />
    <path
      d="M2.66536 8.5H1.33203C1.0587 8.5 0.832031 8.27333 0.832031 8C0.832031 7.72667 1.0587 7.5 1.33203 7.5H2.66536C2.9387 7.5 3.16536 7.72667 3.16536 8C3.16536 8.27333 2.94536 8.5 2.66536 8.5Z"
      fill="black"
    />
    <path
      d="M2.66536 11.167H1.33203C1.0587 11.167 0.832031 10.9403 0.832031 10.667C0.832031 10.3937 1.0587 10.167 1.33203 10.167H2.66536C2.9387 10.167 3.16536 10.3937 3.16536 10.667C3.16536 10.9403 2.94536 11.167 2.66536 11.167Z"
      fill="black"
    />
  </svg>
);
export default Preference;
